import { Component, createRef } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSBox, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { ProjectRow, ProjectInputRow } from "namirasoft-infra";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface ProjectEditPageProps extends NSARouterMakerResult, InfraRouterProps
{
    isEdit: boolean;
}

export default class ProjectEditPage extends Component<ProjectEditPageProps>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSBoxTextArea_Description = createRef<NSBoxTextArea>();

    override render()
    {
        return (
            <InfraLayout<ProjectRow, ProjectInputRow>
                {...this.props}
                pages={{
                    entity: InfraEntities.project(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): ProjectInputRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? null;

                                        return {
                                            workspace_id: "",
                                            name,
                                            description,
                                            project_category: [],
                                            project_field: [],
                                            project_tag: [],
                                        };
                                    },
                                    setRow: (row: ProjectRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString
                        ref={this.NSBoxString_Name}
                        required
                        title="Name"
                        // info={{ link: "https://namirasoft.com/infra/console-guide/project/#field-name" }}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxTextArea
                        ref={this.NSBoxTextArea_Description}
                        required={false}
                        title="Description"
                        // info={{ link: "https://namirasoft.com/infra/console-guide/project/#field-description" }}
                        style={{ width: NSBox.width.double }}
                    />
                </NSColumn>
            </InfraLayout>
        );
    }
}